(function (angular) {
  'use strict';

  angular.module('Common')
    .factory('growlService',
      ['portalConfig', function (portalConfig) {
        var debugGrowlDisplay = portalConfig.debugGrowlDisplay;
        var fac = {
          growl: function (text, type, delay) {

            var icon;

            switch (type) {
              case "success":
                icon = "glyphicon glyphicon-ok";
                break;
              case "danger":
                icon = "glyphicon glyphicon-exclamation-sign";
                break;
              case "warning":
                icon = "glyphicon glyphicon-alert";
                break;
            }

            var options = {
              'type': type,
              z_index: 1100,
            };

            if (delay || delay === 0) {
              options.delay = delay;
            }

            $.growl({
              message: text,
              icon: icon
            }, options);

          },
          success: function (text, delay, debugOnly) {
            if (!debugOnly || (debugGrowlDisplay !== "false")) {
              fac.growl(text, "success", delay);
            }
          },
          danger: function (text, delay, debugOnly) {
            if (!debugOnly || (debugGrowlDisplay !== "false")) {
              fac.growl(text, "danger", 0);
            }
          },
          warning: function (text, delay, debugOnly) {
            if (!debugOnly || (debugGrowlDisplay !== "false")) {
              fac.growl(text, "warning", delay);
            }
          }
        };

        return fac;
      }]);

})(window.angular);
